import React, {FC, useEffect, useRef, useState} from "react";
import {useSelector} from "react-redux";
import queryString from "query-string";
import {IBlogDataPost, IBlogPageCategoryProps} from "../../types/pages";
import {IState} from "../../types/state";
import {useRouter} from "next/router";
import cls from "./blog.module.scss"
import Script from "next/script";
import {schemaBlog} from "../schemaorg";
import BlockLoader from "../blocks/BlockLoader";
import PostCard from "../shared/PostCard";
import PageHeader from "../shared/PageHeader";
import Pagination from "../shared/Pagination";

const buildQuery = (options: { page: number }) => {
    const params = {page: 0};
    if (options.page !== 1) {
        params.page = options.page;
    }
    return queryString.stringify(params, {encode: false});
}

const BlogPageCategory: FC<IBlogPageCategoryProps> = ({
                                                          forBlogType,
                                                          breadcrumb,
                                                          dbName,
                                                          domain,
                                                          layout,
                                                          blog: propsBlog,
                                                          translationsData,
                                                          selectedLocale
                                                      }) => {
    const router = useRouter();
    const [page, setPage] = useState<number>(propsBlog.current_page);
    // const [blogs, setBlogs] = useState<[]>(props.blog.data);
    const [total, _] = useState<number>(propsBlog.total);

    const schema = schemaBlog(domain, dbName, router.asPath, propsBlog.data, "blog")


    const prevLocaleCodeRef: { current: string | undefined } = useRef();
    const prevPageRef: { current: number | undefined } = useRef();

    useEffect(() => {
        prevPageRef.current = page;
        prevLocaleCodeRef.current = selectedLocale;
    }, []);

    useEffect(() => {
        if (page > 1) {
            const query = buildQuery({page});
            const location = `${window.location.pathname}${query ? "?" : ""}${query}`;
            window.history.replaceState(null, "", location);
        } else {
            const location = `${window.location.pathname}`;
            window.history.replaceState(null, "", location);
        }
    }, [page]);

    const handlePageChange = (page: number): void => {
        setPage(page);
    };

    if (!propsBlog.data) {
        return <BlockLoader/>;
    }

    const postsList = propsBlog.data.map((post: IBlogDataPost) => {
        const postLayout: {
            classic: string,
            grid: string,
            list: string,
        } = {
            classic: "grid-lg",
            grid: "grid-nl",
            list: "list-nl",
        }

        return (
            <div key={post.id} className={cls["posts-list__item"]}>
                <PostCard
                    forBLogType={forBlogType}
                    post={post} dbName={dbName}
                    layout={postLayout}
                    domain={domain}
                    translationsData={translationsData}
                />
            </div>
        );
    });

    return (
        <>
            <Script
                id={schema.name}
                type="application/ld+json"
                dangerouslySetInnerHTML={{__html: JSON.stringify(schema)}}
            />
            <PageHeader dbName={dbName} header="Latest News" breadcrumb={breadcrumb}/>
            <div className="container">
                <div className="row">
                    <div>
                        <h1 className={cls["blog-page-title"]}>
                            {translationsData.Blog}
                        </h1>
                        {postsList.length ? (
                            <div className="block">
                                <div
                                    className={cls[`posts-list--layout--${layout}`]}
                                >
                                    <div className={cls["posts-list__body"]}>{postsList}</div>
                                </div>
                                <div className={cls["posts-view__pagination"]}>
                                    {postsList && postsList.length < 20 ? (
                                        <></>
                                    ) : (
                                        <Pagination
                                            current={+page}
                                            siblings={2}
                                            total={total}
                                            onPageChange={handlePageChange}
                                        />
                                    )}
                                </div>
                            </div>
                        ) : (
                            <div className={cls["products-view__empty"]}>
                                <div className={cls["products-view__empty-title"]}>
                                    {translationsData.NothingFound}
                                </div>
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </>
    );
};

export default BlogPageCategory;
